const FALLBACK_CONFIG = {
  googleAds: {
    enabled: true,
    tagId: "AW-17998311177",
    qualifiedViewSendTo: "",
    tutoringSendTo: "AW-17998311177/3RM_CPqbmp4dEIneoYZD",
    registrationSendTo: "AW-17998311177/IPL1CN-TuIUcEIneoYZD",
    purchaseSendTo: "AW-17998311177/g44zCOnlwIUcEIneoYZD",
  },
  meta: { enabled: false, pixelId: "" },
};

let configPromise = null;
let currentConfig = FALLBACK_CONFIG;
let googleConfiguredTagId = "";
let metaConfiguredPixelId = "";
let currentConsentChoice = null;

function isValidMetaPixelId(value) {
  return /^\d{6,32}$/.test(String(value || "").trim());
}

function getConsentChoice() {
  return currentConsentChoice;
}

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function loadScriptOnce(id, src) {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function configureGoogle(config) {
  const google = config?.googleAds || {};
  if (!google.enabled || !google.tagId || googleConfiguredTagId === google.tagId) return;
  ensureGtag();
  loadScriptOnce(
    "matematron-google-tag",
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(google.tagId)}`
  );
  window.gtag("config", google.tagId, { send_page_view: false });
  googleConfiguredTagId = google.tagId;
}

function configureMeta(config) {
  const meta = config?.meta || {};
  if (getConsentChoice() !== "accepted") return;
  if (!meta.enabled || !isValidMetaPixelId(meta.pixelId)) return;
  if (metaConfiguredPixelId === meta.pixelId) return;

  try {
    if (typeof window.fbq !== "function") {
      const fbq = function fbq() {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      window.fbq = fbq;
    }

    loadScriptOnce("matematron-meta-pixel", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", meta.pixelId);
    metaConfiguredPixelId = meta.pixelId;
  } catch {
    // Adblock, CSP albo rozszerzenie przeglądarki nie mogą przerwać działania aplikacji.
  }
}

function canTrackMeta(config) {
  const meta = config?.meta || {};
  return (
    getConsentChoice() === "accepted" &&
    meta.enabled === true &&
    isValidMetaPixelId(meta.pixelId) &&
    metaConfiguredPixelId === meta.pixelId &&
    typeof window.fbq === "function"
  );
}

function trackMetaStandardEvent(config, eventName, params) {
  if (!canTrackMeta(config)) return false;
  try {
    if (params && Object.keys(params).length > 0) window.fbq("track", eventName, params);
    else window.fbq("track", eventName);
    return true;
  } catch {
    return false;
  }
}

function trackMetaCustomEvent(config, eventName, params) {
  if (!canTrackMeta(config)) return false;
  try {
    window.fbq("trackCustom", eventName, params);
    return true;
  } catch {
    return false;
  }
}

function normalizeConfig(value) {
  return {
    googleAds: { ...FALLBACK_CONFIG.googleAds, ...(value?.googleAds || {}) },
    meta: { ...FALLBACK_CONFIG.meta, ...(value?.meta || {}) },
  };
}

export function initializeMarketingMeasurement() {
  if (typeof window === "undefined") return Promise.resolve(FALLBACK_CONFIG);
  if (!configPromise) {
    configPromise = fetch("/api/marketing-measurement/config", {
      credentials: "include",
      cache: "no-store",
    })
      .then((response) => (response.ok ? response.json() : FALLBACK_CONFIG))
      .catch(() => FALLBACK_CONFIG)
      .then((value) => {
        currentConfig = normalizeConfig(value);
        configureGoogle(currentConfig);
        configureMeta(currentConfig);
        return currentConfig;
      });
  }
  return configPromise;
}

export function setMarketingConsent(choice) {
  if (typeof window === "undefined") return;
  currentConsentChoice = choice === "accepted" ? "accepted" : "rejected";
  ensureGtag();
  const granted = choice === "accepted";
  window.gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
    analytics_storage: "denied",
  });
  if (granted) {
    initializeMarketingMeasurement().then(configureMeta);
  }
}

export function trackMarketingPageView(params = {}) {
  initializeMarketingMeasurement().then((config) => {
    if (config.googleAds.enabled && typeof window.gtag === "function") {
      window.gtag("event", "page_view", params);
    }
    trackMetaStandardEvent(config, "PageView");
  });
}

export function trackMarketingEvent(name, params = {}, metaEventName = null) {
  initializeMarketingMeasurement().then((config) => {
    if (config.googleAds.enabled && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
    if (metaEventName) trackMetaStandardEvent(config, metaEventName, params);
    else trackMetaCustomEvent(config, name, params);
  });
}

export function trackMetaEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  initializeMarketingMeasurement().then((config) => {
    trackMetaStandardEvent(config, eventName, params);
  });
}

export function trackGoogleConversion(kind, params = {}) {
  return initializeMarketingMeasurement().then((config) => {
    const sendTo = config.googleAds?.[`${kind}SendTo`];
    if (!config.googleAds?.enabled || !sendTo || typeof window.gtag !== "function") return false;
    window.gtag("event", "conversion", { ...params, send_to: sendTo });
    return true;
  });
}

export function getMarketingMeasurementConfig() {
  return currentConfig;
}
